import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { getColor } from "../tools";
import {
  CustomizedAxisTick,
  CustomTooltip,
} from "../UserTimeline/TimelineItem/LineChart";

export default function CustomStackedAreaChart({
  data,
  quantitativeLabelsChecked,
  qualitativeLabelsChecked,
  height,
}) {
  return (
    <ResponsiveContainer height={height}>
      <AreaChart data={data}>
        <CartesianGrid vertical={false} strokeDasharray="3 3" />
        <XAxis
          dataKey="time"
          height={60}
          domain={["dataMin", "dataMax"]}
          name="Time"
          tick={<CustomizedAxisTick />}
          //interval={time ? "preserveStartEnd" : 0} // 0: all the ticks will be shown
          scale={"auto"}
          type={"category"}
          minTickGap={10}
        />
        <YAxis
          dataKey="value"
          domain={[(dataMin) => 0, (dataMax) => 100]}
          unit="%"
        />
        <Tooltip
          content={
            <CustomTooltip
              quantitativeLabelsChecked={quantitativeLabelsChecked}
              qualitativeLabelsChecked={qualitativeLabelsChecked}
              type="stacked"
            />
          }
          wrapperStyle={{ zIndex: 1 }}
        />
        {quantitativeLabelsChecked.map(({ id, label }) => (
          <Area
            connectNulls
            key={`${id}Area`}
            type="monotone"
            dataKey={`${id}#stacked`}
            stackId="1"
            stroke={getColor(id)}
            fill={getColor(id)}
            //strokeOpacity={`${opacity && !thumbnail ? opacity[id] : 1}`}
            strokeWidth={2}
            dot={{ fill: "#fff", r: 2 }}
            activeDot={{
              r: 4,
            }}
            isAnimationActive={false}
          />
        ))}
      </AreaChart>
    </ResponsiveContainer>
  );
}
